import { render, staticRenderFns } from "./steelBoxSideSpan.vue?vue&type=template&id=394cb406&scoped=true"
import script from "./steelBoxSideSpan.vue?vue&type=script&lang=js"
export * from "./steelBoxSideSpan.vue?vue&type=script&lang=js"
import style0 from "./steelBoxSideSpan.vue?vue&type=style&index=0&id=394cb406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cb406",
  null
  
)

export default component.exports